import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_OR_TABLET_BROWSER, PROMO_TARIFFS } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

const value = isFeature('coverage-1tb-campaign');

if (!IS_MOBILE_OR_TABLET_BROWSER) {
    registerExperiment(
        'coverage-campaign',
        value,
        [
            AnalyticEventNames.ASIDE_COVERAGE_CAMPAIGN_CLICK,
            AnalyticEventNames.ASIDE_COVERAGE_CAMPAIGN_SHOW,
            AnalyticEventNames.FAST_CHECKOUT_SHOWN,
        ],
        {
            sendXrayArgs: {
                [AnalyticEventNames.FAST_CHECKOUT_SHOWN]: ({ productId }, { eventName }) => ({
                    eventName: productId?.startsWith(PROMO_TARIFFS.coverageCampaign) ? 'cvg_camp_checkout' : eventName,
                }),
            },
        }
    );
}

export const coverage1tbCampaign = !IS_MOBILE_OR_TABLET_BROWSER && value;

export const isCoverageCampaign = isFeature('cloud-promo-reach-campaign') || false;

export const coverageCampaignPaymentEnabled = isFeature('cloud-promo-reach-campaign-payment') || false;
const coverageCampaignLastCallValue: 'a' | 'b' | undefined = getFeature('coverage-1tb-campaign-last-call');
export const coverageCampaignLastCall = coverage1tbCampaign && coverageCampaignLastCallValue === 'b';
